






























































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import EmployeeMiniSearch from "../employee/EmployeeSearch.vue";
import ReportDateFilter from "./ReportDateFilter.vue";

const { mapActions: reportsActions, mapGetters: reportsGetters } =
  createNamespacedHelpers("reports");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: "EmployeeReportList",
  components: {
    EmployeeMiniSearch,
    ReportDateFilter,
  },
  data: () => ({
    headers: [
      { text: "Type", value: "report_type", sortable: false },
      { text: "Sales", value: "value", sortable: false },
      { text: "actions", value: "actions", sortable: false },
    ],
    startDate: null as string | null,
    endDate: null as string | null,
    employee: null as { eId: string } | null,
    applyDateFilter: true,
    filterStart: null as string | null,
    filterEnd: null as string | null,
  }),
  computed: {
    ...reportsGetters(["employeeReports", "loading", "error"]),
  },
  watch: {
    startDate() {
      this.fetchEmployeeData();
    },
    endDate() {
      this.fetchEmployeeData();
    },
    employee() {
      this.fetchEmployeeData();
    },
    applyDateFilter(x: boolean) {
      if (!x) {
        this.startDate = null;
        this.endDate = null;
      } else {
        this.startDate = this.filterStart;
        this.endDate = this.filterEnd;
      }
    },
  },
  methods: {
    ...reportsActions(["fetchStaffRevenue"]),
    onRangeChange(filters: { start: string; end: string }) {
      this.filterStart = filters.start;
      this.filterEnd = filters.end;

      if (this.applyDateFilter) {
        this.startDate = filters.start;
        this.endDate = filters.end;
      }
    },
    async fetchEmployeeData() {
      try {
        const params: {
          startDate: string | null;
          endDate: string | null;
          employeeId?: string;
        } = {
          startDate: this.startDate,
          endDate: this.endDate,
        };

        if (this.employee) {
          params.employeeId = this.employee.eId;
        }

        await this.fetchStaffRevenue(params);
      } catch (error) {
        console.error("Error fetching staff revenue:", error);
      }
    },
    clear() {
      this.startDate = null;
      this.endDate = null;
      this.employee = null;
    },
    navigate(item: string) {
      let typex = "service&paymentStatus=completed&type=service";
      if (this.employee) {
        typex += `&staff=${this.employee.eId}`;
      }
      const query: Record<string, string> = {
        tab: "orders",
        staff: typex,
        report: item.toLowerCase().replace(" ", "-"),
      };
      if (this.startDate) {
        const date = new Date(this.startDate);
        date.setHours(0, 0, 0, 0);
        query.startDate = date.toISOString();
      }
      if (this.endDate) {
        const date = new Date(this.endDate);
        date.setHours(23, 59, 59, 59);
        query.endDate = date.toISOString();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this as any).$router.push({
        path: "/reports/employee-report-detail",
        query,
      });
    },
    filterByEmployee(em: { eId: string }) {
      this.employee = em;
    },
    getValueChipColor(value: number): string {
      if (value >= 100000) return "green";
      if (value >= 50000) return "blue";
      if (value >= 10000) return "orange";
      return "grey";
    },
  },
  mounted() {
    this.fetchEmployeeData();
  },
});
